import {ViewController} from "data/types/structure";
import {makeAutoObservable, observable} from "mobx";
import {inject, injectable} from "inversify";
import {ILeague} from "data/types/entities";
import {Bindings} from "data/constants/bindings";
import type {ILeaguesStore} from "data/stores/leagues/leagues.store";

export interface ILeagueManageController extends ViewController {
	get isLoading(): boolean;
	get league(): ILeague | undefined;
	get leagueStarted(): boolean;
}

@injectable()
export class LeagueManageController implements ILeagueManageController {
	constructor(@inject(Bindings.LeaguesStore) private _leagueStore: ILeaguesStore) {
		makeAutoObservable(this);
	}

	@observable private _isLoading: boolean = false;

	get isLoading(): boolean {
		return this._leagueStore.isLoading;
	}

	get league(): ILeague | undefined {
		return this._leagueStore.selectedLeague;
	}

	get leagueStarted(): boolean {
		return this.league?.status !== "scheduled";
	}

	dispose(): void {
		return;
	}

	init(param: void): void {
		return;
	}
}
